import { makeAutoObservable } from 'mobx';
import { enableStaticRendering } from 'mobx-react-lite';
import { Session } from 'next-auth';
import { roles } from '../../model/types';
import { isSSR } from '../../utils/helpers';

enableStaticRendering(isSSR());

export type SecurityStoreHydrationData = Session;

export class SecurityStore {
    accessToken: string;
    email: string;
    refreshToken: string;
    roles: roles[];
    tenantId: string;
    username: string; // TODO: deprecate and use email instead

    constructor(session?: Session) {
        session && this.updateStore(session);
        makeAutoObservable(this);
    }

    updateStore = (session: Session): void => {
        this.accessToken = session?.accessToken;
        this.email = session?.userInfo?.username;
        this.tenantId = session?.tenantId;
        this.refreshToken = session?.refreshToken;
        this.roles = session?.userInfo?.rls;
        this.username = session?.userInfo?.username;
    };
}
